(function(){
    'use strict'; 
    angular.module('app').controller('AccountingIssuedCreditNotesController', AccountingIssuedCreditNotesController); 
    AccountingIssuedCreditNotesController.$inject = [
        'IssuedCreditNotesTable'
    ]; 

    function AccountingIssuedCreditNotesController(
        IssuedCreditNotesTable
    ) {
        const vm = this;

        init();
        function init(){
            vm.issueCreditNotesTableData = new IssuedCreditNotesTable().tableData;
        }
    }
})();  



// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingIssuedCreditNotesController.js